import { CpContractInterface } from '../../../interfaces/dto/contract/cp-contract-interface';
import { CpInsuredPersonModel } from '../insured-person/cp-insured-person-model';
import { ContractParametrizationResponseModel } from '../../response/contract-parametrization/contract-parametrization-response-model';
import { CpPersonModel } from '../person/cp-person-model';
import { CpPolicyHolderModel } from '../policy-holder/cp-policy-holder-model';

export class CpContractModel implements CpContractInterface {
  ContractId: string = '';
  ContractNumber: string = '';
  ContractState: string = '';
  DateEffect: string = '';
  DateStart: string = '';
  InsuredPersons: CpInsuredPersonModel[] = new Array<CpInsuredPersonModel>();
  IsValidateIban: boolean = false;
  Parametrizations: ContractParametrizationResponseModel = new ContractParametrizationResponseModel();
  Person: CpPersonModel = new CpPersonModel();
  PolicyHolder: CpPolicyHolderModel = new CpPolicyHolderModel();
  PresentationContractNumber: string = '';
  ProductName: string = '';
  Role: string = '';
  Token: string = '';
  RequiresConsentAcceptance: boolean = false;
  MaxConsentAttemptsReached: boolean = false;

  constructor(init?: Partial<CpContractModel>) {
    Object.assign(this, init);
  }
}
